export const RULE_NAME = 'rule_name'
export const IS_RULE_ACTIVE = 'is_rule_active'